/**
 * @fileoverview Arrays de cores em formato hexadecimal com correspondência posicional
 * Cada cor na primeira posição do primeiro array tem uma cor correspondente
 * na mesma posição do segundo array
 */

// Array de cores primárias
const mCoresPrimarias = [
  "#969696", // Cinza
  "#2391E1", // Azul
  "#F14444", // Vermelho
  "#029C49", // Verde
  "#874FFF", // Roxo
  "#DF8F16", // Laranja
  "#22BCBF", // Ciano
  "#F849C1", // Rosa
  "#CB4806", // Marrom
  "#F5C542", // Amarelo
  "#8BC34A", // Verde-limão
  "#0D47A1", // Azul escuro
  "#6A1B9A", // Roxo escuro
  "#795548", // Marrom
  "#263238", // Grafite
]

//Array de cores primárias dark mode
const mCoresPrimariasDark = [
  "#575653", // Cinza
  "#4FA7E7", // Azul
  "#F46969", // Vermelho
  "#35B06D", // Verde
  "#AD87FF", // Roxo
  "#E5A545", // Laranja
  "#69D1D4", // Ciano
  "#FA83D5", // Rosa
  "#D56D38", // Marrom
  "#F7D066", // Amarelo
  "#A2D466", // Verde-limão
  "#1E88E5", // Azul escuro
  "#9C4DCC", // Roxo escuro
  "#8D6E63", // Marrom
  "#455A64", // Grafite
]

// Array de cores secundárias correspondentes
const mCoresSecundarias = [
  "#F4F4F4", // Cinza claro (correspondente ao Cinza)
  "#E9F4FC", // Azul claro (correspondente ao Azul)
  "#FEECEC", // Vermelho claro (correspondente ao Vermelho)
  "#E6F5ED", // Verde claro (correspondente ao Verde)
  "#F3EDFF", // Roxo claro (correspondente ao Roxo)
  "#FCF4E8", // Laranja claro (correspondente ao Laranja)
  "#E9F8F9", // Ciano claro (correspondente ao Ciano)
  "#FEEDF9", // Rosa claro (correspondente ao Rosa)
  "#FAEDE6", // Marrom claro (correspondente ao Marrom)
  "#FCF6E8", // Amarelo claro (correspondente ao Amarelo)
  "#F0F7E8", // Verde-limão claro (correspondente ao Verde-limão)
  "#E3EAF5", // Azul escuro claro (correspondente ao Azul escuro)
  "#F0E8F5", // Roxo escuro claro (correspondente ao Roxo escuro)
  "#F3EEEC", // Marrom claro (correspondente ao Marrom)
  "#E8EAEB", // Grafite claro (correspondente ao Grafite)
]

//Array de cores secundárias dark mode
const mCoresSecundariasDark = [
  "#1C1C1C", // Cinza claro (correspondente ao Cinza)
  "#212A30", // Azul claro (correspondente ao Azul)
  "#322424", // Vermelho claro (correspondente ao Vermelho)
  "#1F2B24", // Verde claro (correspondente ao Verde)
  "#2B2733", // Roxo claro (correspondente ao Roxo)
  "#302A20", // Laranja claro (correspondente ao Laranja)
  "#242E2E", // Ciano claro (correspondente ao Ciano)
  "#32262F", // Rosa claro (correspondente ao Rosa)
  "#2F241F", // Marrom claro (correspondente ao Marrom)
  "#302A1A", // Amarelo claro (correspondente ao Amarelo)
  "#272E1F", // Verde-limão claro (correspondente ao Verde-limão)
  "#1A2433", // Azul escuro claro (correspondente ao Azul escuro)
  "#2A1A33", // Roxo escuro claro (correspondente ao Roxo escuro)
  "#2E2624", // Marrom claro (correspondente ao Marrom)
  "#1C2022", // Grafite claro (correspondente ao Grafite)
]

export { mCoresPrimarias, mCoresSecundarias, mCoresPrimariasDark, mCoresSecundariasDark }
